import { AppConfig } from '../../app-config'
import reduxStore from '../../redux/store'
import { triggerSimpleAjax } from '../http-helper'
import is_server from '../is_server'
import get from '../lodashUtils/get'
import isEmpty from '../lodashUtils/isEmpty'
import { INCLUSIONS_VIEW, ITINERARY_VIEW } from '../routesHelper'

const NODE_ENV = process.env.NODE_ENV
const _IS_PROD = NODE_ENV === 'production'

/**
 * List of Events that are tracked as defined constants to use in places needed
 */
const EVENT_LOGO_CLICKED = 'PYT Logo Clicked'
const EVENT_POSTCARD = 'Postcard'
const EVENT_START_PLANNING = 'Started PDG'
const EVENT_RECENTLY_BOOKED = 'Recently Booked'
const EVENT_CBR = 'Call Requested'
const EVENT_PAGE_VISITED = 'Page Viewed'
const EVENT_PACKAGE_SELECTED = 'Package Selected'
const EVENT_SB_CARD_SELECTED = 'Packages_Check_Availability_Clicked'
const EVENT_PACKAGE_FILTERED = 'Package Filtered'
const EVENT_PDG_DESTINATION_SELECTED = 'Destination Selected'
const EVENT_PDG_MONTH_SELECTED = 'Month Selected'
const EVENT_PDG_THEMES_SELECTED = 'Themes Selected'
const EVENT_PDG_CHOOSE_CITIES = 'Customize Cities'
const EVENT_PDG_ITINERARY_CREATED = 'Itinerary Created'
const EVENT_PDG_CITY_ADDED = 'City Added'
const EVENT_PDG_CITY_REMOVED = 'City Removed'
const EVENT_ITINERARY_MODIFIED = 'Itinerary Modified'
const EVENT_ITINERARY_COSTED = 'Costing Updated' // old-name: `Itinerary Costed`
const EVENT_ITINERARY_COSTING_SUBMITTED = 'Itinerary Costing submitted'
const EVENT_INCLUSIONS_MODIFIED = 'Inclusions Modified'
const EVENT_BACK_TO_ITINERARY = 'Back to itinerary'
const EVENT_RENAME_ITINERARY = 'Itinerary Title Changed'
const EVENT_CLOSE_IMAGE_GALLERY = 'Image Gallery Closed'
const EVENT_SORTING_APPLIED = 'Sorting Applied'
const EVENT_INCLUSION_SCROLL_ICON_CLICKED = 'Inclusion Scroll Icon Clicked'
const EVENT_EXPAND_COLLAPSE_ACTIVITIES = 'Inclusion Expand Collapse Activities'
const EVENT_HOTEL_ALTERNATE_CARD_CLICK = 'Hotel Alternates Card Clicked'
const EVENT_HOTEL_ALTERNATE_FITLER_APPLIED = 'Hotel Alternate Filter Applied'
const EVENT_FLIGHT_ALTERNATE_FITLER_APPLIED = 'Flight Alternate Filter Applied'
const EVENT_RENTAL_CAR_ALTERNATE_FITLER_APPLIED =
	'Rental Car Alternate Filter Applied'
const EVENT_ACTIVITY_ALTERNATE_FITLER_APPLIED =
	'Activity Alternate Filter Applied'
const EVENT_GET_TRIP_COST_IN_ITINERARY_PAGE = 'Get Trip Cost In Itinerary Page'
const EVENT_GET_A_PICKYOURTRAIL_ITINERARY = 'Get a Pickyourtrail itinerary'
const EVENT_TALK_TO_EXPERTS_IN_ITINERARY_PAGE =
	'Talk to Experts in itinerary Page'
const EVENT_TOOLTIP_CLOSED = 'Tooltip Closed'
const EVENT_CREATE_YOUR_PERSONALIZED_ITINERARY =
	'create your personalized itinerary'
const EVENT_VACATION_CARD_SELECTED = 'vacation card selected'
const EVENT_EXPLORE_ON_MAP_TOGGLE_BUTTON = 'Explore on Map Toggle Button'
const EVENT_MAP_TOGGLE_FULLSCREEN = 'Map Toggle Fullscreen'
const EVENT_MAP_HOTEL_SELECTED = 'Map Hotel Selected'
const EVENT_MAP_ZOOM_FUNCTION = 'Map Zoom Function'
const EVENT_MAP_NAVIGATION = 'Map Navigation'

const EVENT_QUOTE_REQUESTED = 'Quote Requested'
const EVENT_BOOKING_INITIATED = 'Booking Initiated'
const EVENT_PAX_FILLED = 'Pax Details filled'
const EVENT_COST_REVIEWED = 'Cost Reviewed'
const EVENT_PAYMENT_INITIATED = 'Payment Initiated'
const EVENT_PAYMENT_SUCCESS = 'Payment Success'
const EVENT_PAYMENT_FAILED = 'Payment Failed'
const EVENT_BOOKING_COMPLETED = 'Booking completed'
const EVENT_BOOKING_TIMED_OUT = 'Booking Timed out'
const EVENT_COUPON_APPLIED = 'Coupon Applied'
const EVENT_COUPON_REMOVED = 'Coupon Removed'
const EVENT_LOGOUT = 'User Logout'

const EVENT_CHAT_REQUESTED = 'Whatsapp chat initiated'
const EVENT_CANCELLATION_POLICY = 'Cancellation Policy Viewed'
const EVENT_YOUR_VACATIONS = 'Your Vacations Viewed'
const EVENT_BLOG_VIEWED = 'Blog Viewed'
const EVENT_TESTIMONIAL_VIEWED = 'Testimonial Viewed'

// Activity Overview events
const EVENT_AO_OPEN_OR_CLOSE = 'AO Open Or Close'
const EVENT_AO_TAG_CLICKED = 'AO Tag Clicked'
const EVENT_AO_ADD_ACTIVITY = 'AO Add Activity'
const EVENT_AO_REMOVE = 'AO Remove'
const EVENT_AO_VIEW_DETAILS = 'AO View Details'
const EVENT_AO_VIEW_SIMILAR = 'AO View Similar'
const EVENT_AO_PREVIOUS_ACTIVITY = 'AO Previous Activity'
const EVENT_AO_NEXT_ACTIVITY = 'AO Next Activity'
const EVENT_AO_UPGRADE_ACTIVITY = 'AO Upgrade added'

// flight modal events
const EVENT_ALTERNATE_FLIGHT_CARD_CLICK = 'Alternate flight card clicked'

//common events
const EVENT_BREADCRUMB_CLICK = 'Breadcrumb click'
const EVENT_REMOVE_CLICK = 'Remove button clicked'
const EVENT_CLOSE_CLICK = 'Close button click'
const EVENT_SHOW_DETAILS = 'View Details Clicked'
const EVENT_CHANGE_CLICK = 'Change Clicked'
const EVENT_FOOTER_DESTINATION_CLICK = 'Footer destination clicked'
const EVENT_INSTALL_APP_CTA_CLICK = 'Install Mobile App CTA'

// UI button events to track interaction types
const EVENT_CATEGORY_CITY = 'City'
const EVENT_CATEGORY_NIGHT = 'Night'
const EVENT_CATEGORY_ACTIVITY = 'Activity'
const EVENT_CATEGORY_ROOM = 'Room'
const EVENT_CHANGES_APPLIED = 'Changes Applied'
const EVENT_ADD = 'Add'
const EVENT_EDIT = 'Edit'
const EVENT_CHANGE = 'Change'
const EVENT_REMOVE = 'Remove'
const EVENT_REPLACE = 'Replace'
const EVENT_PACKAGES_EDIT = 'Packages Edit'
const EVENT_VIEW_MORE_ACTIVITY = 'View More Activity'
const EVENT_EDIT_ROUTE_CLICKED = 'costed_page_edit_route_clicked'
const EVENT_PACKAGE_FORM_FIELD = 'Packages Form Field Filled'
// UI position/place of the events tracked/occurred
const EVENT_POSITION_HEADER = 'Header'
const EVENT_POSITION_FOOTER = 'Footer'

// User Profile events
const USER_LOGIN = 'Login'
const USER_SIGNUP = 'Signup'
const USER_LOGIN_GETCOST = 'Login - Get Cost'
const USER_SIGNUP_GETCOST = 'Signup - Get Cost'
const USER_SIGNUP_SHARE_ITINERARY = 'Signup - Share Itinerary'
const USER_FORGOT_PASSWORD = 'Forgot Password'
// page call names
const PAGE_PACKAGES = 'Packages Page'
const PAGE_PDG = 'PDG Customize Page'
const PAGE_TESTIMONIALS = 'Testimonials Page'
const PAGE_CAREERS = 'Careers'
const PAGE_ABOUT = 'About Us'
const PAGE_CONTACT = 'Contact'
const PAGE_FAQ = 'FAQ'
const PAGE_TERMS = 'T&C'
const PAGE_PRIVACY = 'Privacy Policy'
const PAGE_CANCELLATION = 'Cancellation Policy'

//Subscribe event
const SUBSCRIBE = 'Newsletter Subscribed'
//Packages region rating event
const REGION_RATING = 'Region Rating'
const EVENT_T20_SUBMIT = 'T20 Submit '
//Packages - book it list
const EVENT_PDF_VIEWED = 'Pdf Viewed'

// split stay
const EVENT_SPLIT_STAY_ADD = 'Split stay added'
const EVENT_SPLIT_STAY_EDIT = 'Split stay Edited'
const EVENT_SPLIT_STAY_REMOVE = 'Split stay Deleted'

// Dubai
const EVENT_BACK_BTN_CLICK = 'Back button clicked'
const EVENT_NEXT_BTN_CLICK = 'Next button clicked'
const EVENT_DEPARTURE_DESCLAIMER_CLICK = 'Departure City question'
const EVENT_DEPARTURE_CITY_CHANGE = 'Departure City changed'
const EVENT_DEPARTURE_MONTH_CLICK = 'Departure month clicked'
const EVENT_DROP_POSTCARD_CLICK = 'Drop postcard clicked'
const EVENT_DATE_SELECT = 'Date Selected'
const EVENT_DAYS_SELECT = 'No-of days selected'
const EVENT_TRAVELLER_TYPE_SELECT = 'Traveller details filled'
const EVENT_ROOM_CONFIG_CHANGE = 'Room Configuration changed'
const EVENT_ATTRACTION_SELECT = 'Attraction selected'
const EVENT_SAVED_ITINERARY_CLICK = 'Saved itineraries clicked '
const EVENT_ITINERARY_DAY_BAR_CLICK = 'Itinerary day bar clicked'
const EVENT_EDIT_TITLE_CLICK = 'Edit Title Clicked'
const EVENT_DELETE_DAY_CLICK = 'Delete Day Clicked'
const EVENT_ADD_DAY_CLICK = 'Add Another Day Clicked'
const EVENT_ACTIVITY_OPEN = 'Activity Overview Opened'
const EVENT_REVIEW_INCLUSION = 'Review inclusions Summary'
const EVENT_REVIEW_INCLUSION_FOOTER = 'Review inclusions Footer'

// T-20 Event
const WCT20_PACKAGE_TYPE_SELECTED = 'WCT20 Package type selected'
const WCT20_MATCH_SELECTED = 'WCT20 Match selected'
const WCT20_WOMENS_PACKAGE_CLICKED = 'WCT20 Womens T20 packages clicked'
const WCT20_MENS_PACKAGE_CLICKED = 'WCT20 Mens T20 packages clicked'
const WCT20_PACKAGE_CARD_SELECTED = 'WCT20 T20 package card selected'

// Project Dawn (Homepage Revamp) Events
const EVENT_DAWN_WORLD_MAP_POPUP_SHOWN = 'World Map'
const EVENT_DAWN_SEASONAL_CAMPAIGN = 'Seasonal Campaign'
const EVENT_DAWN_TESTIMONIALS = 'hp_testimonials'
const EVENT_DAWN_BLOG = 'Blog Selected'
const EVENT_DAWN_COSTED_USER_LATEST_ITINERARY = 'Latest Itinerary Clicked'
const EVENT_DAWN_COSTED_VIEW_ALL_ITINERARIES = 'View All itineraries Clicked'
const EVENT_DAWN_THEMED_ITINERARIES = 'Themed Itinerary'
const EVENT_DAWN_PACKAGE_ITINERARIES = 'Package Selected'
const EVENT_DAWN_SECOND_LAST_ITINERARY_CLICKED = 'Second Last Itinerary Clicked'

// zest Events
const EVENT_ZEST_KNOW_MORE = 'Zest Know More Clicked'

//SMM Events
const EVENT_SMM_CBR = 'PMob CBR Given'
const EVENT_SSM_CUSTOMISE_CLICKED = 'PMob Customise Clicked'
const EVENT_SSM_ITINERARY_COSTED = 'PMob Itinerary Costed'
const EVENT_SSM_CBR_CLOSED = 'PMob CBR Closed'
const EVENT_SSM_SIGNUP_CLOSED = 'PMob Sign-Up Closed'
const EVENT_SSM_LOGIN_CLOSED = 'PMob Login Closed'
const EVENT_SSM_GCM_CLOSED = 'PMob GCM Closed'

//deals Events
const EVENT_PAYMENT_DETAILS_CLICKED = 'Enter Payment Details Clicked'
const EVENT_TOGGLE_ITINERARY_VIEW_CLICKED = 'Toggle Itinerary View Clicked'
const EVENT_FAQ_CLICKED = 'FAQ Question Selected'
const EVENT_HEADER_TAB_SELECTED = 'Deals_DP_BannerImageButton_Selected'
const EVENT_SHARE_DEAL_CLICK = 'Deals_DP_ShareThisDeal_Selected'
const EVENT_CONDITION_APPLY_SELECTED = 'Condition Apply Selected'
const EVENT_VIEW_YOUR_BOOKING_CLICKED = 'View Your Bookings Clicked'
const EVENT_CONTACT_US_CLICKED = 'Contact Us Clicked'
const EVENT_DETAILS_OF_STAY_SELECTED = 'Details of Stay Selected'
const EVENT_DEALS_CARD_CLICKED = 'Deals Card Selected'
const EVENT_TOGGLE_ACTIVITY_VIEW_CLICKED = 'Toggle Activity View Clicked'
const EVENT_DEALS_DP_GALLERY = 'Deals_DP_Gallery_opened'
const EVENT_DEALS_READ_MORE_CLICKED = 'Deals_DP_Read_More_clicked'
const EVENT_DEAL_CARD_IMAGE_SWIPED = 'deal_card_image_swiped'
const EVENT_DEAL_SIMILAR_CLICKED = 'Deals_DP_Similar_Deals_clicked'
const EVENT_DEAL_FAQ_SEARCH = 'Deals_DP_FAQ_Search'
const EVENT_DEAL_GALLERY_VIEWED = 'Deals_DP_GalleryImage_viewed'
const EVENT_DEAL_ADDONS = 'Deals_DP_Addons'
const EVENT_DEAL_CALENDAR_DATE_CHANGE = 'Deals_DP_calendar_date_change'
const EVENT_DEAL_VIEW_ALL_UPGRADE = 'Deals_DP_View_all_upgrades_clicked'
const EVENT_DEAL_ROOM_CHANGED = 'Deals_DP_Room_Changed'
const EVENT_DEAL_FAQ = 'Deals_DP_FAQ'
const EVENT_DEAL_ROOM_CONFIG_CHANGED = 'Deals_DP_Room_Config_Changed'
const EVENT_DEAL_PHONE_NUMBER_CLICKED = 'Deals_DP_Phone_Icon_clicked'
const EVENT_DEAL_COUPON_APPLIED = 'Deals_PD_Coupon_Code_Applied'
const EVENT_DEAL_LOYALTY_APPLIED = 'Deals_DP_Loyalty_Credits_Applied'
const EVENT_DEAL_PASSENGER_CONFIG_CHANGED = 'Deals_DP_passenger_config_changed'
const EVENT_DEAL_COUPON_POPUP = 'deals_anon_coupon_popup_clicked'
const EVENT_COUPON_GENERATED_FROM_MODAL = 'deals_anon_coupon_generated'
const EVENT_COUPON_TAKE_ME_TO_DEALS = 'deals_anon_coupon_takemetodeals'

//deals
const EVENT_DEALS_SIGN_UP = 'User Signup'
const EVENT_BOOK_THIS_DEAL = 'Deals_DP_book_this_deal_clicked'
const EVENT_STAYCATION_READ_MORE = 'Read more button clicked'
const EVENT_DEALS_REGISTER_CLICKED = 'deals_register_clicked'
const EVENT_DEALS_COMMUNITY_BUTTON_CLICKED = 'community_button_clicked'
const EVENT_JOIN_DEALS_CLICKED = 'join_deals_clicked'
const EVENT_CHECK_AVAILABILITY = 'check_availability'
const EVENT_JOIN_DOMESTIC_CLICKED = 'join_domestic_clicked'
const EVENT_DEALS_LISTING_CARD_CLICKED = 'deals_listing_card_clicked'
const EVENT_DEALS_LISTING_FILTER_APPLIED = 'deals_listing_filter_applied'
const EVENT_DEALS_LISTING_SORT_CLICKED = 'deals_listing_sort_clicked'

/**
 * global events
 */
const EVENT_HOMEPAGE_SEARCH_CLICKED = 'hp_search_clicked'
const EVENT_HOMEPAGE_PRIMARY_CTA_CLICKED = 'hp_explore_deals_clicked'
const EVENT_HOMEPAGE_SECONDARY_CTA_CLICKED = 'hp_plan_your_own_trip_clicked'
const EVENT_HOMEPAGE_POPULAR_DESTINATION_CLICKED =
	'hp_popular_destinations_clicked'
const EVENT_CREATE_MY_ACCOUNT_CLICKED = 'Create my Account button clicked'
const EVENT_CONTINUE_AS_GUEST_CLICKED = 'Continue as Guest link clicked'

//home page
const EVENT_HOMEPAGE_IOS_APP_CLICKED = 'hp_iOS_download_clicked'
const EVENT_HOMEPAGE_ANDROID_APP_CLICKED = 'hp_android_download_clicked'

const EVENT_STAYS_CLICKED = 'uncosted_page_stays clicked'
const EVENT_TRANSFER_CLICKED = 'uncosted_page_transfer clicked'
const EVENT_ACTIVITIES_CLICKED = 'uncosted_page_activities clicked'
const EVENT_MORE_CLICKED = 'uncosted_page_more clicked'
const EVENT_REVIEW_NEXT_CLICKED = 'Next review costs button clicked'
const EVENT_STAY_COSTED_CLICKED = 'costed_page_stays clicked'
const EVENT_TRANSFER_COSTED_CLICKED = 'costed_page_transfer clicked'
const EVENT_ACTIVITIES_COSTED_CLICKED = 'costed_page_activities clicked'
const EVENT_MORE_COSTED_CLICKED = 'costed_page_more clicked'
const EVENT_FLIGHTS_CLICKED = 'uncosted_page_flights clicked'
const EVENT_FLIGHTS_COSTED_CLICKED = 'costed_page_flights clicked'
const EVENT_JOURNEYS_CARD_CLICKED = 'Journeys_Cards_Clicked'
const EVENT_NEED_HELP_CLICKED = 'Need_Help_clicked'
const EVENT_REQUEST_CALL_BACK_CLICKED = 'Request_Call_Back_Click'
const EVENT_DAY_BY_DAY_CLICKED = 'Day_By_day_clicked'
const EVENT_STAY_CLICKED = 'Stay_Clicked'
const EVENT_TRANSFER_JOURNEYS_CLICKED = 'transfer_Clicked'
const EVENT_MORE_JOURNEYS_CLICKED = 'More_Clicked'
const EVENT_PYT_RECOMENDED_FILTER_CLICKED = 'PYTRecomendedFilter'
const EVENT_Filter_CLICKED = 'FIlterSelected'
const EVENT_CREATE_NOW_CLICKED = 'Create_now_clicked'
const EVENT_VIEW_ALL_PACKAGES_CLICKED = 'View_all_packages_Clicked'
const EVENT_MOBILE_NUMBER_RCB_CLICKED = 'MobNumEnteredforRCB'
const EVENT_BOOK_NOW_CLICKED = 'Journeys_BookNow_Clicked'
const EVENT_PROCEED_BOOK_NOW_CLICKED = 'Journeys_Proceed_to_Book_Clicked'
const EVENT_OTP_VERIFIED_CLICKED = 'OTPVerified_continue_Clicked'
const EVENT_PACKAGE_ITINERARY_CLICKED = 'Packages_itinerary_Selected'
const EVENT_PYT_LOGO_CLICKED = 'PYT_Logo_click'

//Affiliate page
const EVENT_AFFILIATE_LP = 'Affiliate LP - Component Clicked'

// Fresh Chat Events
const EVENT_FRESH_CHAT_OPENED = 'Fresh Chat Opened'

const EVENT_LOYALTY_APPLIED = 'Loyalty_Credits_Applied'

//otp login
const EVENT_MOB_NO_ENTERED_FOR_OTP = 'MobNoEnteredForOTPVerification'

//getOtpNewUser
const EVENT_GET_OTP_NEW_USER = 'getOtpNewUser'

//resendOtp
const EVENT_RE_SEND_OTP = 'resendOtp'

//MORE EMI OPTIONS CLICKED
const EVENT_MORE_EMI_OPTIONS_CLICKED = 'MoreEmiOptionsClicked'

// Language based lead allocation events
const EVENT_CHOOSE_LANGUAGE = 'ChooseLanguage'

const EVENT_HEADER_PACKAGES_CLICKED = 'Header_packages'

/**
 * Segment Event Tracker
 * @param {string} eventName - event name
 * @param {object} props - list of attributes need to be captured on particular event
 */
const trackEvent = (eventName, props = {}) => {
	const hasAnalytics = global.analytics
	// if (window.analytics) {
	//check if props is object, change it to valid object if it is not one.
	props = typeof props === 'object' && !Array.isArray(props) ? props : { props }
	let eventProps = {}
	let storeData = {}
	storeData = reduxStore.getState()

	const userType = get(storeData, 'userDetails.userType')
	const skipUserTypes = [
		'ADMIN',
		'CURATOR',
		'FRANCHISEADVISOR',
		'FRANCHISELEAD',
	]
	if (!_IS_PROD || skipUserTypes.includes(userType)) {
		return false
	}
	try {
		const itineraryInfo = storeData.app.itineraryInfo || {}
		const maldivesData = storeData.maldivesData
		props.region_code =
			itineraryInfo.itinerary && itineraryInfo.itinerary.regionCode
		props.region_name =
			itineraryInfo.itinerary && itineraryInfo.itinerary.region
		let resortData = {}
		if (itineraryInfo.version === 'SPEEDBALI') {
			props.region_code = 'idn'
			props.region_name = 'bali'
		}
		if (itineraryInfo.version === 'SANDUNE') {
			props.region_code = 'dxb'
			props.region_name = 'dubai'
		}
		if (
			(maldivesData.preCostedResorts &&
				Object.keys(maldivesData.preCostedResorts).length) ||
			itineraryInfo.version === 'SPEEDBOAT'
		) {
			let hotelData = {}
			if (
				maldivesData.preCostedResorts &&
				Object.keys(maldivesData.preCostedResorts).length
			) {
				hotelData = {
					hotelCode: maldivesData.preCostedResorts.resortCode,
					name: maldivesData.preCostedResorts.resortName,
				}
			}
			if (itineraryInfo.version === 'SPEEDBOAT') {
				const hotelRef = itineraryInfo.allHotelCostingRefs[0]
				hotelData =
					itineraryInfo.hotelCostings &&
					itineraryInfo.hotelCostings.costingById[hotelRef]
			}
			resortData = {
				resort_id: (hotelData || {}).hotelCode,
				resort_name: (hotelData || {}).name,
				region_code: 'mle',
				region_name: 'Maldives',
			}
		}
		if (itineraryInfo.version !== 'DEAL') {
			props = { ...props, ...resortData }
		}

		switch (eventName) {
			case EVENT_START_PLANNING:
				props = {
					...props,
					element_name:
						props.element_name || 'btn_pdg_create_itinerary_packages',
				}
				break
			case EVENT_DAWN_PACKAGE_ITINERARIES:
				props = {
					...props,
					is_card_clicked: true,
					element_type: 'card',
					element_name: 'card_package',
				}
				break
			case EVENT_PDG_DESTINATION_SELECTED:
				props = {
					...props,
					element_type: 'dropdown',
					element_name: 'dd_pdg_destination',
				}
				break
			case EVENT_PDG_MONTH_SELECTED:
				props = {
					...props,
					element_type: 'dropdown',
					element_name: 'dd_pdg_month',
				}
				break
			case EVENT_DAYS_SELECT:
				props = {
					...props,
					element_type: 'dropdown',
					element_name: 'dd_pdg_duration',
				}
				break
			case EVENT_PDG_THEMES_SELECTED:
				props = {
					...props,
					element_type: 'dropdown',
					element_name: 'dd_pdg_themes',
				}
				break
			case EVENT_PDG_CHOOSE_CITIES:
				props = {
					...props,
					element_type: 'dropdown',
					element_name: 'dd_pdg_choose_cities',
				}
				break
			case EVENT_ITINERARY_COSTING_SUBMITTED:
				props = {
					...props,
					element_type: 'button',
					element_name: 'btn_gcm_get_cost',
				}
				break
			case EVENT_CANCELLATION_POLICY:
				props = {
					...props,
					element_type: 'button',
					element_name: 'btn_cancellation_policy_top_bar',
				}
				break
			case EVENT_PAX_FILLED:
				{
					let pax_details = []
					props.pax_details.forEach(room => {
						room.forEach(item => {
							const { type, birthDay, firstName, lastName, salutation } = item
							pax_details.push({
								type,
								firstName,
								lastName,
								salutation,
								birthday: new Date(birthDay),
							})
						})
					})
					props = {
						...props,
						pax_details,
						element_type: 'button',
						element_name: 'btn_make_payment_booking_travellers',
					}
				}
				break
			case EVENT_COST_REVIEWED:
				props = {
					...props,
					element_type: 'button',
					element_name: 'btn_review_costs_live_cost',
				}
				break
			case EVENT_PAYMENT_INITIATED:
				props = {
					...props,
					element_type: 'button',
					element_name: 'btn_pay_now',
				}
				break
			case EVENT_PACKAGE_SELECTED:
				props = {
					...props,
					element_type: 'card',
					element_name: 'card_package',
				}
				break
			case EVENT_CBR:
				{
					/**
					 * Pass different element names based on the page they triggered the Callback request
					 * |----------------------------------------------|------------------------------------------------------------------------|
					 * | element_name                                 | scenario where it is triggered                                         |
					 * |----------------------------------------------|------------------------------------------------------------------------|
					 * |btn_call_back_request_homepage                | homepage                                                               |
					 * |btn_call_back_request_itinerary               | Itinerary View Page                                                    |
					 * |btn_call_back_request_inclusions              | Itinerary Inclusions Page                                              |
					 * |btn_call_back_request_paid_campaign_exitpp    | Any paid campaign pages on exit intend(moving cursor out from viewport)|
					 * |btn_call_back_request_paid_campaign_floating  | submitting form from bottom floating button on paid campaign pages     |
					 * |btn_call_back_request_packages__exitpp        | Any packages page on exit intend(moving cursor out from viewport)      |
					 * |btn_call_back_request_packages__floating      | submitting form from bottom floating button on any packages page       |
					 * |----------------------------------------------|------------------------------------------------------------------------|
					 */
					let ename = 'btn_call_back_request_homepage'
					if (typeof props.pageURL === 'string') {
						if (props.pageURL?.includes(`/${ITINERARY_VIEW}/`))
							ename = 'btn_call_back_request_itinerary'
						else if (props.pageURL?.includes(`/${INCLUSIONS_VIEW}/`))
							ename = 'btn_call_back_request_inclusions'
						else {
							const { packages = {} } = storeData
							const { content } = packages
							let isPaid = null,
								exit_intend = null
							// check paid flag from packages object to identify the packages page type
							if (
								content &&
								typeof content === 'object' &&
								Object.keys(content).length
							) {
								const { campaignDetails = {} } = content
								isPaid = campaignDetails.paid
							}
							// check autocbr query parameter to identify how the CBR is triggered on packages
							if (props.pageURL?.includes('&autocbr')) {
								exit_intend = true
							}
							if (isPaid) {
								ename = `btn_call_back_request_paid_campaign_${
									exit_intend ? 'exitpp' : 'floating'
								}`
							} else {
								ename = `btn_call_back_request_packages_${
									exit_intend ? 'exitpp' : 'floating'
								}`
							}
						}
					}
					props = {
						...props,
						element_type: 'button',
						element_name: ename,
					}
				}
				break
			case EVENT_CHAT_REQUESTED:
				{
					const pathName = get(storeData, 'router.location.pathname')
					const isCosted = get(storeData, 'app.itineraryInfo.itinerary.costed')
					const isCam = get(storeData, 'app.packages.campaignDetails.key')
					if (
						!get(storeData, 'app.itineraryInfo.itinerary.campaign') &&
						!isCam == 'packages'
					) {
						// PDG flow
						if (!isCosted) {
							props = {
								...props,
								placement: 'Itinerary_created',
							}
						} else if (isCosted) {
							props = { ...props, placement: 'Itinerary_costed' }
						}
					} else get(storeData, 'app.itineraryInfo.itinerary.campaign')
					{
						const t20It = get(storeData, 'app.itineraryInfo.version')
						if (pathName.split('/').includes('icc-t20-men-worldcup-packages')) {
							// eventProps['placement'] = 'WCT20_listing'
							// props = { eventProps,};
							props = {
								...props,
								placement: 'WCT20_listing',
							}
						}
						if (pathName.split('/').includes('icc-t20-worldcup-event-men')) {
							props = {
								...props,
								placement: 'WCT20_home',
							}
						}
						if (
							get(storeData, 'app.itineraryInfo.itinerary.costed') &&
							t20It == 'WORLDCUP_T20_MEN'
						) {
							props = {
								...props,
								placement: 'WCT20_created',
							}
						}

						//maldives

						const isMal = get(storeData, 'maldivesData.preCostedResorts')

						if (!isEmpty(isMal)) {
							props = {
								...props,
								placement: 'Speedboat_created',
							}
						}
						//  Packages flow

						if (pathName.split('/').includes('packages')) {
							const isCampIt = get(
								storeData,
								'app.itineraryInfo.itinerary.campaign',
							)
							if (!isCosted && !isCampIt) {
								props = {
									...props,
									placement: 'Packages_listing',
								}
							}

							if (isCampIt) {
								props = {
									...props,
									placement: 'packages_created',
								}
							}
							if (isCosted && !isCampIt) {
								props = {
									...props,
									placement: 'Packages_costed',
								}
							}
						}
						if (pathName.split('/').includes('cred-offers')) {
							if (!isCosted) {
								props = {
									...props,
									placement: 'cred_home',
								}
							} else if (isCosted) {
								props = {
									...props,
									placement: 'cred_costed',
								}
							}
						}
					}
				}
				break
			case EVENT_PDG_ITINERARY_CREATED:
				props = {
					...props,
					city: storeData.pdg.selectedCityNames,
					destination: storeData.pdg.regionDetails.regionName,
					element_type: 'button',
					element_name: 'btn_build_itinerary',
				}
				break
			case EVENT_PAYMENT_SUCCESS:
				{
					const { payment = {} } = storeData
					const { paymentProcessing = {} } = payment
					props = {
						...props,
						amount: paymentProcessing.amount,
					}
				}
				break
			case EVENT_PAYMENT_FAILED:
				{
					const { payment = {} } = storeData
					const { paymentProcessing = {} } = payment
					props = {
						...props,
						amount: paymentProcessing.amount,
					}
				}
				break
			case WCT20_PACKAGE_TYPE_SELECTED:
			case WCT20_MATCH_SELECTED:
			case WCT20_PACKAGE_CARD_SELECTED:
			case WCT20_MENS_PACKAGE_CLICKED:
			case WCT20_WOMENS_PACKAGE_CLICKED: {
				props = {
					...props,
				}
				break
			}
			case EVENT_BOOKING_INITIATED:
				{
					const months = [
						'JAN',
						'FEB',
						'MAR',
						'APR',
						'MAY',
						'JUN',
						'JUL',
						'AUG',
						'SEP',
						'OCT',
						'NOV',
						'DEC',
					]
					const {
						itinerary = {},
						cityById = {},
						allFlightCostingRefs = [],
						allHotelCostingRefs = [],
						allTransferCostingRefs = [],
						allTrainCostingRefs = [],
						allFerryCostingRefs = [],
						allVisaCostingRefs = [],
						allRentalCostingRefs = [],
						insuranceCosting = {},
						activityCostings = {},
						costingConfiguration = {},
						paymentSchedule = {},
					} = itineraryInfo.itineraryDetails
					const activities = Object.keys(
						activityCostings.costingById || {},
					).map(key => {
						const item = activityCostings.costingById[key]
						return `${item.activityName} - ${item.cityText}`
					})
					const cities = Object.keys(cityById).map(key => {
						const item = cityById[key]
						return item.cityName
					})
					props = {
						element_type: 'button',
						element_name: 'btn_book_your_trip_top_bar',
						...props,
						total_flights: allFlightCostingRefs.length,
						total_hotels: allHotelCostingRefs.length,
						total_transfers: allTransferCostingRefs.length,
						total_trains: allTrainCostingRefs.length,
						total_ferry: allFerryCostingRefs.length,
						total_rentals: allRentalCostingRefs.length,
						activities,
						cities,
						visa_included: allVisaCostingRefs.length ? true : false,
						insurance_included:
							typeof insuranceCosting.costingById === 'object' &&
							insuranceCosting.costingById.required
								? true
								: false,
						adult_count: itineraryInfo.adult_count,
						child_count: itineraryInfo.child_count,
						total_cost: parseInt(
							(paymentSchedule.itineraryTotalCost + '').replace(/,/g, ''),
						),
						month: costingConfiguration.departureDate
							? months[new Date(costingConfiguration.departureDate).getMonth()]
							: '',
						departure_date: costingConfiguration.departureDate
							? new Date(costingConfiguration.departureDate)
							: '',
						departure_city: costingConfiguration.departureCity,
						is_agent: itinerary.agent || false,
						destination: itinerary.countries.map(country => country.name),
					}
				}
				break
			case EVENT_ALTERNATE_FLIGHT_CARD_CLICK:
				props = {
					element_type: 'card',
					element_name: 'card_alternate_flight_card_click',
					...props,
				}
				break
			case EVENT_LOGOUT:
				if (hasAnalytics) {
					window.__analytics_reset && clearTimeout(window.__analytics_reset)
					window.__analytics_reset = setTimeout(() => {
						global.analytics.reset()
					}, 1000)
				}
				break
			default:
				if (Object.values({}).includes(eventName)) {
					props = {}
				}
				break
		}
		/**
		 * Check property keys for array type values in any key.
		 * Convert arrays to comma separated values and assign it to same key.
		 * Also add '{attrName}_array' key to store the actual array values
		 * And add '{attrName}_count' key to store the array size
		 */
		for (let key in props) {
			const attr = props[key]
			if (Array.isArray(attr)) {
				eventProps[`${key}_array`] = attr
				eventProps[`${key}_count`] = attr.length
				/**
				 * If array contains reference types(Objects/arrays) convert them accordingly.
				 * Check on first index of the array to find the type of values the array contains
				 */
				eventProps[key] =
					typeof attr[0] === 'object' ? JSON.stringify(attr) : attr.join()
			} else {
				eventProps[key] = attr
			}
		}
	} catch (e) {
		eventProps = props
		// console.log('trackEvent', e);
	}

	// console.log(global.analytics.track)
	// typeof eventName === 'string' && hasAnalytics && global.analytics.track(eventName, eventProps);

	/**
	 * BE api user tracker
	 * @param {string} name, {string} itineraryId , {object} attributes
	 */
	if (typeof eventName === 'string') {
		try {
			if (!is_server()) {
				const ipInfo = JSON.parse(localStorage.getItem('user-ip-info')) || {}

				eventProps.page_url = window.location.href
				eventProps.landingPage = sessionStorage.getItem('source')
				eventProps.ipAddress = sessionStorage.getItem('ipaddress')
				eventProps.leadSource = JSON.parse(sessionStorage.getItem('leadSource'))
				eventProps.leadSource = {
					...(JSON.parse(sessionStorage.getItem('leadSource')) || {}),
					ipInfo,
				}

				eventProps.is_logged_in = get(
					storeData,
					'app.user_details.loggedIn',
					false,
				)
				eventProps.page_referrer = document.referrer
				eventProps.page_title = document.title
				eventProps.userAgent = navigator.userAgent
			} else {
				eventProps.ipAddress = get(storeData, 'app.ipaddress', false)
				eventProps.is_logged_in = get(
					storeData,
					'app.user_details.loggedIn',
					false,
				)
			}

			// Push event data to DataLayer - Start here
			window.dataLayer = window.dataLayer || []
			window.dataLayer.push({
				eventName,
				...eventProps,
			})
			// Push event data to DataLayer - Ends here

			triggerSimpleAjax({
				url: `${AppConfig.api_url}lead-intel/event`,
				method: 'POST',
				body: {
					name: eventName,
					itineraryId: eventProps.itinerary_id ? eventProps.itinerary_id : '',
					attributes: eventProps,
				},
				onSuccess: () => {
					// we are not handling any responses for events
				},
				onFailure: err => {
					// eslint-disable-next-line no-console
					console.warn && console.warn(err)
				},
			})
		} catch (ex) {
			// eslint-disable-next-line no-console
			console.warn && console.warn(ex)
		}
	}
	// }
}

/**
 * Segment User Tracker
 * @param {string} eventType
 * @param {object} props - list of attributes need to be captured on user signup/login
 */
const trackProfile = (eventType, props = {}) => {
	const isLogin = [USER_LOGIN, USER_LOGIN_GETCOST].includes(eventType)
	const isSignup = [
		USER_SIGNUP,
		USER_SIGNUP_GETCOST,
		USER_SIGNUP_SHARE_ITINERARY,
	].includes(eventType)

	if (isLogin || isSignup) {
		const { mobileNumber, name, email, prod_type } = props
		const attrs = {
			signup: isSignup,
			name,
			email,
			phone: mobileNumber,
			prod_type: prod_type,
		}
		if (eventType === USER_SIGNUP_SHARE_ITINERARY) {
			attrs.share_itinerary = true
		}
		if (sessionStorage && sessionStorage.getItem('campaignId')) {
			attrs.cpid = sessionStorage.getItem('campaignId')
		}
		trackEvent(eventType, attrs)
		if (
			isSignup &&
			sessionStorage &&
			sessionStorage.getItem('USER_HASH_DATA')
		) {
			attrs.unsubscribe_hash = sessionStorage.getItem('USER_HASH_DATA')

			sessionStorage.removeItem('USER_HASH_DATA')
		}
		global.analytics && global.analytics.identify(mobileNumber, attrs)
	}
}

/**
 * Segment Page call Tracker
 * @param {string} pageName
 * @param {object} props - list of attributes need to be captured on page calls
 */
const trackPage = (pageName, props = {}) => {
	//check if props is object, change it to valid object if it is not one.
	props = typeof props === 'object' && !Array.isArray(props) ? props : { props }

	trackEvent('page load', { name: pageName, ...props })
}

export {
	EVENT_LOGO_CLICKED,
	EVENT_POSTCARD,
	EVENT_CBR,
	EVENT_START_PLANNING,
	EVENT_RECENTLY_BOOKED,
	EVENT_PAGE_VISITED,
	EVENT_PACKAGE_SELECTED,
	EVENT_SB_CARD_SELECTED,
	EVENT_PACKAGE_FILTERED,
	EVENT_PDG_DESTINATION_SELECTED,
	EVENT_PDG_MONTH_SELECTED,
	EVENT_DAYS_SELECT,
	EVENT_PDG_THEMES_SELECTED,
	EVENT_PDG_CHOOSE_CITIES,
	EVENT_PDG_ITINERARY_CREATED,
	EVENT_PDG_CITY_ADDED,
	EVENT_PDG_CITY_REMOVED,
	EVENT_ITINERARY_MODIFIED,
	EVENT_ITINERARY_COSTED,
	EVENT_ITINERARY_COSTING_SUBMITTED,
	EVENT_INCLUSIONS_MODIFIED,
	EVENT_BACK_TO_ITINERARY,
	EVENT_RENAME_ITINERARY,
	EVENT_CLOSE_IMAGE_GALLERY,
	EVENT_SORTING_APPLIED,
	EVENT_INCLUSION_SCROLL_ICON_CLICKED,
	EVENT_EXPAND_COLLAPSE_ACTIVITIES,
	EVENT_HOTEL_ALTERNATE_CARD_CLICK,
	EVENT_HOTEL_ALTERNATE_FITLER_APPLIED,
	EVENT_FLIGHT_ALTERNATE_FITLER_APPLIED,
	EVENT_RENTAL_CAR_ALTERNATE_FITLER_APPLIED,
	EVENT_ACTIVITY_ALTERNATE_FITLER_APPLIED,
	EVENT_GET_TRIP_COST_IN_ITINERARY_PAGE,
	EVENT_TALK_TO_EXPERTS_IN_ITINERARY_PAGE,
	EVENT_QUOTE_REQUESTED,
	EVENT_BOOKING_INITIATED,
	EVENT_PAX_FILLED,
	EVENT_COST_REVIEWED,
	EVENT_PAYMENT_INITIATED,
	EVENT_PAYMENT_SUCCESS,
	EVENT_PAYMENT_FAILED,
	EVENT_BOOKING_TIMED_OUT,
	EVENT_BOOKING_COMPLETED,
	EVENT_COUPON_APPLIED,
	EVENT_COUPON_REMOVED,
	EVENT_LOGOUT,
	EVENT_CHAT_REQUESTED,
	EVENT_CANCELLATION_POLICY,
	EVENT_YOUR_VACATIONS,
	EVENT_BLOG_VIEWED,
	EVENT_TESTIMONIAL_VIEWED,
	EVENT_CATEGORY_CITY,
	EVENT_CATEGORY_NIGHT,
	EVENT_CATEGORY_ACTIVITY,
	EVENT_CATEGORY_ROOM,
	EVENT_CHANGES_APPLIED,
	EVENT_ADD,
	EVENT_EDIT,
	EVENT_CHANGE,
	EVENT_REMOVE,
	EVENT_REPLACE,
	EVENT_PACKAGES_EDIT,
	EVENT_VIEW_MORE_ACTIVITY,
	EVENT_POSITION_HEADER,
	EVENT_POSITION_FOOTER,
	EVENT_AO_OPEN_OR_CLOSE,
	EVENT_AO_TAG_CLICKED,
	EVENT_AO_ADD_ACTIVITY,
	EVENT_AO_REMOVE,
	EVENT_AO_VIEW_DETAILS,
	EVENT_AO_VIEW_SIMILAR,
	EVENT_AO_PREVIOUS_ACTIVITY,
	EVENT_AO_NEXT_ACTIVITY,
	EVENT_AO_UPGRADE_ACTIVITY,
	EVENT_GET_A_PICKYOURTRAIL_ITINERARY,
	EVENT_TOOLTIP_CLOSED,
	EVENT_EXPLORE_ON_MAP_TOGGLE_BUTTON,
	EVENT_MAP_TOGGLE_FULLSCREEN,
	EVENT_MAP_HOTEL_SELECTED,
	EVENT_MAP_ZOOM_FUNCTION,
	EVENT_MAP_NAVIGATION,
	USER_LOGIN,
	USER_SIGNUP,
	USER_LOGIN_GETCOST,
	USER_SIGNUP_GETCOST,
	USER_SIGNUP_SHARE_ITINERARY,
	USER_FORGOT_PASSWORD,
	PAGE_PACKAGES,
	PAGE_PDG,
	PAGE_TESTIMONIALS,
	PAGE_CAREERS,
	PAGE_ABOUT,
	PAGE_CONTACT,
	PAGE_FAQ,
	PAGE_TERMS,
	PAGE_PRIVACY,
	PAGE_CANCELLATION,
	EVENT_BREADCRUMB_CLICK,
	EVENT_REMOVE_CLICK,
	EVENT_CLOSE_CLICK,
	EVENT_SHOW_DETAILS,
	EVENT_CHANGE_CLICK,
	EVENT_FOOTER_DESTINATION_CLICK,
	EVENT_INSTALL_APP_CTA_CLICK,
	EVENT_ALTERNATE_FLIGHT_CARD_CLICK,
	EVENT_CREATE_YOUR_PERSONALIZED_ITINERARY,
	EVENT_VACATION_CARD_SELECTED,
	EVENT_T20_SUBMIT,
	SUBSCRIBE,
	REGION_RATING,
	EVENT_SPLIT_STAY_ADD,
	EVENT_SPLIT_STAY_EDIT,
	EVENT_SPLIT_STAY_REMOVE,
	EVENT_BACK_BTN_CLICK,
	EVENT_NEXT_BTN_CLICK,
	EVENT_DEPARTURE_DESCLAIMER_CLICK,
	EVENT_DEPARTURE_CITY_CHANGE,
	EVENT_DEPARTURE_MONTH_CLICK,
	EVENT_DROP_POSTCARD_CLICK,
	EVENT_DATE_SELECT,
	EVENT_TRAVELLER_TYPE_SELECT,
	EVENT_ROOM_CONFIG_CHANGE,
	EVENT_ATTRACTION_SELECT,
	EVENT_SAVED_ITINERARY_CLICK,
	EVENT_ITINERARY_DAY_BAR_CLICK,
	EVENT_EDIT_TITLE_CLICK,
	EVENT_DELETE_DAY_CLICK,
	EVENT_ADD_DAY_CLICK,
	EVENT_ACTIVITY_OPEN,
	EVENT_REVIEW_INCLUSION,
	EVENT_REVIEW_INCLUSION_FOOTER,
	trackEvent,
	trackProfile,
	trackPage,
	WCT20_PACKAGE_TYPE_SELECTED,
	WCT20_MATCH_SELECTED,
	WCT20_WOMENS_PACKAGE_CLICKED,
	WCT20_MENS_PACKAGE_CLICKED,
	WCT20_PACKAGE_CARD_SELECTED,
	EVENT_DAWN_WORLD_MAP_POPUP_SHOWN,
	EVENT_DAWN_SEASONAL_CAMPAIGN,
	EVENT_DAWN_TESTIMONIALS,
	EVENT_DAWN_BLOG,
	EVENT_DAWN_COSTED_USER_LATEST_ITINERARY,
	EVENT_DAWN_COSTED_VIEW_ALL_ITINERARIES,
	EVENT_DAWN_THEMED_ITINERARIES,
	EVENT_DAWN_PACKAGE_ITINERARIES,
	EVENT_DAWN_SECOND_LAST_ITINERARY_CLICKED,
	EVENT_PDF_VIEWED,
	EVENT_ZEST_KNOW_MORE,
	EVENT_SMM_CBR,
	EVENT_SSM_CUSTOMISE_CLICKED,
	EVENT_SSM_ITINERARY_COSTED,
	EVENT_SSM_CBR_CLOSED,
	EVENT_SSM_SIGNUP_CLOSED,
	EVENT_SSM_LOGIN_CLOSED,
	EVENT_SSM_GCM_CLOSED,
	EVENT_FRESH_CHAT_OPENED,
	EVENT_PAYMENT_DETAILS_CLICKED,
	EVENT_TOGGLE_ITINERARY_VIEW_CLICKED,
	EVENT_FAQ_CLICKED,
	EVENT_HEADER_TAB_SELECTED,
	EVENT_SHARE_DEAL_CLICK,
	EVENT_CONDITION_APPLY_SELECTED,
	EVENT_VIEW_YOUR_BOOKING_CLICKED,
	EVENT_CONTACT_US_CLICKED,
	EVENT_DETAILS_OF_STAY_SELECTED,
	EVENT_DEALS_CARD_CLICKED,
	EVENT_TOGGLE_ACTIVITY_VIEW_CLICKED,
	EVENT_DEALS_SIGN_UP,
	EVENT_BOOK_THIS_DEAL,
	EVENT_STAYCATION_READ_MORE,
	EVENT_DEALS_REGISTER_CLICKED,
	EVENT_DEALS_COMMUNITY_BUTTON_CLICKED,
	EVENT_JOIN_DEALS_CLICKED,
	EVENT_CHECK_AVAILABILITY,
	EVENT_JOIN_DOMESTIC_CLICKED,
	EVENT_DEALS_LISTING_CARD_CLICKED,
	EVENT_DEALS_LISTING_FILTER_APPLIED,
	EVENT_DEALS_LISTING_SORT_CLICKED,
	EVENT_DEAL_CARD_IMAGE_SWIPED,
	EVENT_HOMEPAGE_SEARCH_CLICKED,
	EVENT_HOMEPAGE_POPULAR_DESTINATION_CLICKED,
	EVENT_HOMEPAGE_PRIMARY_CTA_CLICKED,
	EVENT_HOMEPAGE_SECONDARY_CTA_CLICKED,
	EVENT_CREATE_MY_ACCOUNT_CLICKED,
	EVENT_CONTINUE_AS_GUEST_CLICKED,
	EVENT_REVIEW_NEXT_CLICKED,
	EVENT_STAYS_CLICKED,
	EVENT_TRANSFER_CLICKED,
	EVENT_ACTIVITIES_CLICKED,
	EVENT_MORE_CLICKED,
	EVENT_STAY_COSTED_CLICKED,
	EVENT_TRANSFER_COSTED_CLICKED,
	EVENT_ACTIVITIES_COSTED_CLICKED,
	EVENT_MORE_COSTED_CLICKED,
	EVENT_FLIGHTS_CLICKED,
	EVENT_FLIGHTS_COSTED_CLICKED,
	EVENT_HOMEPAGE_IOS_APP_CLICKED,
	EVENT_HOMEPAGE_ANDROID_APP_CLICKED,
	EVENT_EDIT_ROUTE_CLICKED,
	EVENT_AFFILIATE_LP,
	EVENT_DEALS_DP_GALLERY,
	EVENT_DEALS_READ_MORE_CLICKED,
	EVENT_DEAL_PHONE_NUMBER_CLICKED,
	EVENT_DEAL_COUPON_APPLIED,
	EVENT_DEAL_LOYALTY_APPLIED,
	EVENT_DEAL_FAQ_SEARCH,
	EVENT_DEAL_FAQ,
	EVENT_DEAL_GALLERY_VIEWED,
	EVENT_DEAL_ADDONS,
	EVENT_DEAL_CALENDAR_DATE_CHANGE,
	EVENT_DEAL_VIEW_ALL_UPGRADE,
	EVENT_DEAL_ROOM_CHANGED,
	EVENT_DEAL_ROOM_CONFIG_CHANGED,
	EVENT_DEAL_PASSENGER_CONFIG_CHANGED,
	EVENT_DEAL_SIMILAR_CLICKED,
	EVENT_DEAL_COUPON_POPUP,
	EVENT_COUPON_GENERATED_FROM_MODAL,
	EVENT_COUPON_TAKE_ME_TO_DEALS,
	EVENT_LOYALTY_APPLIED,
	EVENT_PACKAGE_FORM_FIELD,
	EVENT_MOB_NO_ENTERED_FOR_OTP,
	EVENT_MORE_EMI_OPTIONS_CLICKED,
	EVENT_CHOOSE_LANGUAGE,
	EVENT_GET_OTP_NEW_USER,
	EVENT_RE_SEND_OTP,
	EVENT_JOURNEYS_CARD_CLICKED,
	EVENT_NEED_HELP_CLICKED,
	EVENT_REQUEST_CALL_BACK_CLICKED,
	EVENT_DAY_BY_DAY_CLICKED,
	EVENT_STAY_CLICKED,
	EVENT_TRANSFER_JOURNEYS_CLICKED,
	EVENT_MORE_JOURNEYS_CLICKED,
	EVENT_PYT_RECOMENDED_FILTER_CLICKED,
	EVENT_Filter_CLICKED,
	EVENT_CREATE_NOW_CLICKED,
	EVENT_VIEW_ALL_PACKAGES_CLICKED,
	EVENT_MOBILE_NUMBER_RCB_CLICKED,
	EVENT_BOOK_NOW_CLICKED,
	EVENT_PROCEED_BOOK_NOW_CLICKED,
	EVENT_OTP_VERIFIED_CLICKED,
	EVENT_PACKAGE_ITINERARY_CLICKED,
	EVENT_PYT_LOGO_CLICKED,
	EVENT_HEADER_PACKAGES_CLICKED,
}
